import {
  InjectedLLMJudge,
  LLMJudgeError,
  type InjectedInvoker,
} from "./shared.js";

/**
 * Gemini CLI host adapter for `LLMJudge`.
 *
 * Gemini's natural surface for a single-shot decision query is an **MCP call**
 * — the host routes the framed prompt through its model-call tool and returns
 * the text. The host injects that call; the shared base supplies framing +
 * parsing. Host-specific surface is the `host` identifier (`"gemini"`,
 * matching the sessionArchive adapter convention) and the typed error.
 */

/** Gemini's MCP-call invoker — a `prompt in, string out` call. */
export type GeminiMcpInvoker = InjectedInvoker;

export class GeminiLLMJudgeError extends LLMJudgeError {
  constructor(message: string, raw?: string) {
    super(message, raw);
    this.name = "GeminiLLMJudgeError";
  }
}

export class GeminiLLMJudge extends InjectedLLMJudge {
  readonly host = "gemini";

  protected override makeError(message: string, raw?: string): Error {
    return new GeminiLLMJudgeError(message, raw);
  }
}
